/**
 * callback Adjust Cuenta de Ahorros
 *
 * *Constant eventsAdjustCA configuration*
 */
export const callbackAdjustCA = [
  { key: 'Channel', value: 'SA' },
  { key: 'Country', value: 'CO' },
  { key: 'Client_Type', value: 'PF' },
  { key: 'Area', value: 'NL' },
  { key: 'Family', value: 'Cuentas' },
  { key: 'SubFamily', value: 'Ahorro' },
  { key: 'Action', value: 'Contratar' },
];

/**
 * callback Adjust Tarjeta de Credito
 *
 * *Constant eventoAdjustSolicitarTC configuration*
 */
export const callbackAdjustSolicitarTC = [
  { key: 'Channel', value: 'SA' },
  { key: 'Country', value: 'CO' },
  { key: 'Client_Type', value: 'PF' },
  { key: 'Area', value: 'NL' },
  { key: 'Family', value: 'Tarjetas' },
  { key: 'SubFamily', value: 'Credito' },
  { key: 'Action', value: 'Solicitar' },
];
/**
 * callback Adjust Tarjeta de Credito
 *
 * *Constant callbackAdjustContratarTC configuration*
 */
export const callbackAdjustContratarTC = [
  { key: 'Channel', value: 'SA' },
  { key: 'Country', value: 'CO' },
  { key: 'Client_Type', value: 'PF' },
  { key: 'Area', value: 'NL' },
  { key: 'Family', value: 'Tarjetas' },
  { key: 'SubFamily', value: 'Credito' },
  { key: 'Action', value: 'Contratar' },
];
